import { getAllData } from "./firebase/firestore/getAllData";
import { uploadDataWithName } from "./firebase/firestore/uploadDataWithName";
import { getClients } from "./toggl/getClients";

export const syncFirebaseAndTogglClients = (onComplete, onError) => {
  // get clients from toggl
  // get clients from toggl
  getClients((clients) => {
    // get clients from firebase
    getAllData("clients", (firebaseClients) => {
      const firebaseClientNames = firebaseClients.map((client) => {
        return client.name;
      });

      let promises = [];

      // check if clients from toggl are in firebase
      clients.forEach((client) => {
        // if client is not in firebase, then add it
        if (!firebaseClientNames.includes(client.name)) {
          promises.push(addClientToFirebase(client));
        } else {
          console.log("client in firebase", client.name);
        }
      });

      // wait for all promises to resolve
      Promise.all(promises)
        .then(() => {
          let numberOfClientsAdded = promises.length;
          onComplete(numberOfClientsAdded);
        })
        .catch((error) => {
          console.log(error);
          onError(error);
        });
    });
  });
};

// add client to firebase
const addClientToFirebase = (client) => {
  return new Promise((resolve, reject) => {
    let data = {
      name: client.name,
    };

    uploadDataWithName(
      data,
      "clients",
      String(client.id),
      () => {
        console.log("client added to firebase", client.name);
        resolve();
      },
      (error) => {
        console.log(error);
        reject();
      }
    );
  });
};
